import 'babel-polyfill';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '../../directives'
import '../../utils/filter'
import TeachingUI from 'teaching-ui'

import '../../plugins/element.js'
import store from '../../store'

Vue.config.productionTip = false

Vue.use(TeachingUI)

// 解决ie9-bug： el-input 删除完内容，失去焦点后又展示删除之前的内容 YuAng
Vue.prototype.changeValue = function (e) {
  return e.target.value
}

new Vue({
  render: h => h(App),
  router,
  store,
  methods: {
    activeNavigation: function () {
      const target = this.$root.$children[0].$children[0]
      if (target.matchNavigator) {
        const navigator = target.navigators.find(item => item.active === true)
        if (navigator) {
          navigator.active = false
          if (navigator.children && navigator.children.length > 0) {
            const child = navigator.children.find(item => item.active === true)
            if (child) {
              child.active = false
            }
          }
          target.matchNavigator()
        }
      }
    }
  }
}).$mount('#app')
